import React from "react";
import HTMLReactParser from "html-react-parser";
import { useAppSelector } from "@/redux/reduxHooks";

import { WeatherStationDataEmailTableDataType } from "@/types/EmailTemplateTypes";
import {
  explanationAlternariaInfestationData,
  explanationPhytophthoraInfestationData,
  infestationColor,
  tendencyData,
} from "../home/weatherStationData/weatherLegends";

// import PModelBanner from "../../assets/pmodel-banner.svg";
import PmodelMain from "../../assets/PModel_Main.png";
import Cropwise from "../../assets/Cropwise.png";
import "./emailTemplate.less";

type EmailTemplatePropType = {
  emailSendDate: string;
  emailTitle: string;
  emailSalutation: string;
  emailTeaserText: string;
  emailRecommendedContent: { university: string; syngenta: string };
  emailTableData: WeatherStationDataEmailTableDataType[];
};

const EmailTemplate = ({
  emailRecommendedContent,
  emailTitle,
  emailSalutation,
  emailTeaserText,
  emailTableData,
  emailSendDate,
}: EmailTemplatePropType) => {
  const user = useAppSelector((state) => state.user);

  return (
    <div className="email-template">
      <div className="email-header">
        <div className="date">{emailSendDate}</div>
        {/* <img src={PModelBanner} alt="PModel Banner" className="banner-img" /> */}
        <div
          style={{
            backgroundColor: "#e39d42",
            height: "10px",
          }}
        ></div>
        <div style={{ textAlign: "right" }}>
          <img
            src={PmodelMain}
            alt="PModel Banner"
            className="banner-img"
            style={{ width: "600px", height: "100px" }}
          />
        </div>
      </div>
      <div
        style={{
          backgroundColor: "rgb(157 105 32)",
          height: "10px",
        }}
      ></div>
      <div
        style={{
          backgroundColor: "rgb(205 120 58)",
          height: "10px",
        }}
      ></div>
      <div
        className="email-body"
        style={{
          backgroundColor: "#e39d42",
          margin: "0px 0px",
          color: "white",
        }}
      >
        <span style={{ width: "5%", display: "inline-block" }}></span>
        <span style={{ width: "65%", display: "inline-block" }}>
          <div
            className="email-title"
            id="email-title"
            style={{ paddingTop: "15px", fontSize: "25px" }}
          >
            {HTMLReactParser(emailTitle || "")}
          </div>
          <div
            className="email-salutation"
            style={{ fontSize: "40px", margin: "0px 0px", paddingTop: "20px" }}
          >
            {HTMLReactParser(emailSalutation || "")}&nbsp;{user.salutation}
          </div>

          <div className="email-username" style={{ fontSize: "40px" }}>
            {user.firstName} {user.lastName}
          </div>

          <div
            className="email-teaser-text"
            id="email-teaser-text"
            style={{ paddingTop: "20px", fontSize: "25px" }}
          >
            {/* {htmlToText(emailTeaserText)} */}
            {HTMLReactParser(emailTeaserText || "")}
          </div>
        </span>
        <span
          style={{ width: "30%", display: "inline-block", textAlign: "right" }}
        >
          <div
            style={{
              textAlign: "right",
              marginRight: "20px",
              paddingBottom: "40px",
            }}
          >
            <img src={Cropwise} alt="Cropwise" className="banner-img" />
          </div>
        </span>
      </div>

      <div className="email-recommendation university">
        <span style={{ width: "5%", display: "inline-block" }}></span>
        <span style={{ width: "90%", display: "inline-block" }}>
          <div
            className="recommendation-title"
            style={{
              width: "95%",
              color: "rgb(227 157 66)",
              borderTop: "3px solid rgb(227 157 66)",
              paddingTop: "20px",
              marginBottom: "20px 20px",
            }}
          >
            Empfehlungstext der Universität
          </div>

          <div
            className="email-recommendation-text-by-university"
            id="email-recommendation-text-by-university"
            style={{
              // paddingRight: "180px",
              paddingTop: "20px",
              width: "95%",
            }}
          >
            {/* {HTMLReactParser(emailRecommendedContent.university || "")} */}
            {HTMLReactParser(emailRecommendedContent.university?.replace(
              /<p><br><\/p>/g,
              "",
            ) || "")}
          </div>
        </span>
        <span style={{ width: "5%", display: "inline-block" }}></span>
      </div>

      <div className="email-recommendation syngenta">
        <span style={{ width: "5%", display: "inline-block" }}></span>
        <span style={{ width: "90%", display: "inline-block" }}>
          <div
            className="recommendation-title"
            style={{
              width: "95%",
              color: "rgb(227 157 66)",
              borderTop: "3px solid rgb(227 157 66)",
              paddingTop: "20px",
              marginBottom: "20px 20px",
            }}
          >
            Empfehlung der Syngenta
          </div>

          <div
            className="email-recommendation-text-by-syngenta"
            id="email-recommendation-text-by-syngenta"
            style={{
              // paddingRight: "180px",
              paddingTop: "20px",
              width: "95%",
            }}
          >
            {/* {HTMLReactParser(emailRecommendedContent.syngenta || "")} */}
            {HTMLReactParser(emailRecommendedContent.syngenta?.replace(
              /<p><br><\/p>/g,
              "",
            ) || "")}
          </div>
        </span>
        <span style={{ width: "5%", display: "inline-block" }}></span>
      </div>

      <div className="table-container">
        <span style={{ width: "5%", display: "inline-block" }}></span>
        <span style={{ width: "90%", display: "inline-block" }}>
          <div
            className="recommendation-title"
            style={{
              width: "95%",
              color: "rgb(227 157 66)",
              borderTop: "3px solid rgb(227 157 66)",
              paddingTop: "0px",
              marginBottom: "20px 20px",
            }}
          >
            <h4 className="table-title">Alles auf einen Blick</h4>
          </div>

          <div
            className="email-recommendation-text-by-syngenta"
            id="email-recommendation-text-by-syngenta"
            style={{
              paddingRight: "60px",
              paddingTop: "10px",
            }}
          >
            <p className="para-text">
              Ihre regionalen Boniturergebnisse und Prognosen für Berlin
            </p>
            <br />
            {/* <table className="scoutedFieldsTable" style={{ width: "100%" }}>
              <tbody>
                <tr className="weatherStationHeader">
                  <td
                    style={{
                      backgroundColor: "rgb(237 237 237)",
                      borderRadius: "8px",
                      textAlign: "left",
                      paddingLeft: "20px",
                      color: "black",
                      fontWeight: "bold",
                      border: "none",
                    }}
                    colSpan={6}
                    className="table-heading weatherStationName"
                  >
                    Wetterstation
                  </td>
                </tr>

                <tr className="tableHeader1">
                  <td
                    className="column"
                    style={{
                      border: "none",
                      backgroundColor: "white",
                      fontWeight: "normal",
                    }}
                  >
                    Witterungsbedingter
                    <br />
                    Epidemiedruck
                    <br />
                    Phytophthora
                  </td>
                  <td
                    className="column"
                    style={{
                      border: "none",
                      backgroundColor: "white",
                      fontWeight: "normal",
                    }}
                  >
                    3-Tages-
                    <br />
                    Prognose
                    <br /> Phytophthora
                  </td>
                  <td
                    className="column"
                    style={{
                      border: "none",
                      backgroundColor: "white",
                      fontWeight: "normal",
                    }}
                  >
                    Witterungsbedingter
                    <br />
                    Epidemiedruck
                    <br />
                    Alternaria
                  </td>
                  <td
                    className="column"
                    style={{
                      border: "none",
                      backgroundColor: "white",
                      fontWeight: "normal",
                    }}
                  >
                    3-Tages-
                    <br />
                    Prognose
                    <br />
                    Alternaria
                  </td>
                  <td
                    className="column"
                    style={{
                      border: "none",
                      backgroundColor: "white",
                      fontWeight: "normal",
                    }}
                  >
                    Spritzabstand
                  </td>
                  <td
                    className="column"
                    style={{
                      border: "none",
                      backgroundColor: "white",
                      fontWeight: "normal",
                    }}
                  ></td>
                </tr>

                <tr>
                  <td
                    className="data-column"
                    style={{
                      border: "none",
                      borderTop: "2px solid rgb(237 237 237)",
                    }}
                  >
                    11
                  </td>
                  <td
                    className="data-column"
                    style={{
                      border: "none",
                      borderTop: "2px solid rgb(237 237 237)",
                    }}
                  >
                    22
                  </td>
                  <td
                    className="data-column"
                    style={{
                      border: "none",
                      borderTop: "2px solid rgb(237 237 237)",
                    }}
                  >
                    33
                  </td>
                  <td
                    className="data-column"
                    style={{
                      border: "none",
                      borderTop: "2px solid rgb(237 237 237)",
                    }}
                  ></td>
                  <td
                    className="data-column"
                    style={{
                      border: "none",
                      borderTop: "2px solid rgb(237 237 237)",
                    }}
                  >
                    44
                  </td>
                  <td
                    className="data-column"
                    style={{
                      border: "none",
                      borderTop: "2px solid rgb(237 237 237)",
                    }}
                  ></td>
                </tr>

                <tr className="tableHeader2">
                  <td
                    className="table-heading weatherStationMonitoringText"
                    colSpan={6}
                    style={{
                      backgroundColor: "rgb(237 237 237)",
                      borderRadius: "8px",
                      textAlign: "left",
                      paddingLeft: "20px",
                      color: "black",
                      fontWeight: "bold",
                      border: "none",
                    }}
                  >
                    Praxisschlag (Monitoring-Fläche)
                  </td>
                </tr>

                <tr className="tableHeader3">
                  <td
                    className="column"
                    style={{
                      border: "none",
                      backgroundColor: "white",
                      fontWeight: "normal",
                    }}
                  >
                    Standort (LKR)
                  </td>
                  <td
                    className="column"
                    style={{
                      border: "none",
                      backgroundColor: "white",
                      fontWeight: "normal",
                    }}
                  >
                    Sorte (Auflauftermin)
                  </td>
                  <td
                    className="column"
                    style={{
                      border: "none",
                      backgroundColor: "white",
                      fontWeight: "normal",
                    }}
                  >
                    Befall (unbehandelt)
                  </td>
                  <td
                    className="column"
                    style={{
                      border: "none",
                      backgroundColor: "white",
                      fontWeight: "normal",
                    }}
                  >
                    Anzahl Spritzungen
                  </td>
                  <td
                    className="column"
                    style={{
                      border: "none",
                      backgroundColor: "white",
                      fontWeight: "normal",
                    }}
                  >
                    Phytophthora Befall
                  </td>
                  <td
                    className="column"
                    style={{
                      border: "none",
                      backgroundColor: "white",
                      fontWeight: "normal",
                    }}
                  >
                    Alternaria Befall
                  </td>
                </tr>

                <tr>
                  <td
                    className="data-column"
                    rowSpan={1}
                    style={{
                      border: "2px solid rgb(237 237 237)",
                    }}
                  >
                    11
                  </td>
                  <td
                    className="data-column"
                    style={{
                      border: "2px solid rgb(237 237 237)",
                    }}
                  >
                    22
                  </td>
                  <td
                    className="data-column"
                    style={{
                      border: "2px solid rgb(237 237 237)",
                    }}
                  >
                    33
                  </td>
                  <td
                    className="data-column"
                    style={{
                      border: "2px solid rgb(237 237 237)",
                    }}
                  >
                    44
                  </td>
                  <td
                    align="center"
                    className="data-column"
                    style={{
                      border: "2px solid rgb(237 237 237)",
                    }}
                  ></td>
                  <td
                    className="data-column"
                    style={{
                      border: "2px solid rgb(237 237 237)",
                    }}
                  ></td>
                </tr>
              </tbody>
            </table> */}

            {emailTableData.map((weatherStationData, idx) => (
              <table
                key={idx}
                className="scoutedFieldsTable"
                style={{ width: "100%" }}
              >
                <tbody>
                  <tr className="weatherStationHeader">
                    <td
                      colSpan={6}
                      className="table-heading weatherStationName"
                      style={{
                        backgroundColor: "rgb(237 237 237)",
                        borderRadius: "8px",
                        textAlign: "left",
                        paddingLeft: "20px",
                        color: "black",
                        fontWeight: "bold",
                        border: "none",
                      }}
                    >
                      Wetterstation {weatherStationData.weatherStationName}
                    </td>
                  </tr>

                  <tr className="tableHeader1">
                    <td
                      className="column"
                      style={{
                        border: "none",
                        backgroundColor: "white",
                        fontWeight: "normal",
                      }}
                    >
                      Witterungsbedingter
                      <br />
                      Epidemiedruck
                      <br />
                      Phytophthora
                    </td>
                    <td
                      className="column"
                      style={{
                        border: "none",
                        backgroundColor: "white",
                        fontWeight: "normal",
                      }}
                    >
                      3-Tages-
                      <br />
                      Prognose
                      <br /> Phytophthora
                    </td>
                    <td
                      className="column"
                      style={{
                        border: "none",
                        backgroundColor: "white",
                        fontWeight: "normal",
                      }}
                    >
                      Witterungsbedingter
                      <br />
                      Epidemiedruck
                      <br />
                      Alternaria
                    </td>
                    <td
                      className="column"
                      style={{
                        border: "none",
                        backgroundColor: "white",
                        fontWeight: "normal",
                      }}
                    >
                      3-Tages-
                      <br />
                      Prognose
                      <br />
                      Alternaria
                    </td>
                    <td
                      className="column"
                      style={{
                        border: "none",
                        backgroundColor: "white",
                        fontWeight: "normal",
                      }}
                    >
                      Spritzabstand
                    </td>
                    <td
                      className="column"
                      style={{
                        border: "none",
                        backgroundColor: "white",
                        fontWeight: "normal",
                      }}
                    ></td>
                  </tr>

                  <tr>
                    <td
                      className="data-column"
                      style={{
                        border: "none",
                        borderTop: "2px solid rgb(237 237 237)",
                      }}
                    >
                      {weatherStationData.pytophthoraEpidemicPressure}
                    </td>
                    <td
                      className="data-column"
                      style={{
                        border: "none",
                        borderTop: "2px solid rgb(237 237 237)",
                      }}
                    >
                      <img
                        src={
                          tendencyData.find(
                            (tnd) =>
                              tnd.tendencyValue.toString() ==
                              weatherStationData.threeDayForecast,
                          )?.icon
                        }
                        alt={
                          tendencyData.find(
                            (tnd) =>
                              tnd.tendencyValue.toString() ==
                              weatherStationData.threeDayForecast,
                          )?.key
                        }
                      />
                    </td>
                    <td
                      className="data-column"
                      style={{
                        border: "none",
                        borderTop: "2px solid rgb(237 237 237)",
                      }}
                    >
                      {weatherStationData.alternariaEpidemicPressure}
                    </td>
                    <td
                      className="data-column"
                      style={{
                        border: "none",
                        borderTop: "2px solid rgb(237 237 237)",
                      }}
                    >
                      <img
                        src={
                          tendencyData.find(
                            (tnd) =>
                              tnd.tendencyValue.toString() ==
                              weatherStationData.threeDayPrognosisAlternaria,
                          )?.icon
                        }
                        alt={
                          tendencyData.find(
                            (tnd) =>
                              tnd.tendencyValue.toString() ==
                              weatherStationData.threeDayPrognosisAlternaria,
                          )?.key
                        }
                      />
                    </td>
                    <td
                      className="data-column"
                      style={{
                        border: "none",
                        borderTop: "2px solid rgb(237 237 237)",
                      }}
                    >
                      {weatherStationData.sprayDistance}
                    </td>
                    <td
                      className="data-column"
                      style={{
                        border: "none",
                        borderTop: "2px solid rgb(237 237 237)",
                      }}
                    ></td>
                  </tr>

                  <tr className="tableHeader2">
                    <td
                      className="table-heading weatherStationMonitoringText"
                      colSpan={6}
                      style={{
                        backgroundColor: "rgb(237 237 237)",
                        borderRadius: "8px",
                        textAlign: "left",
                        paddingLeft: "20px",
                        color: "black",
                        fontWeight: "bold",
                        border: "none",
                      }}
                    >
                      Praxisschlag (Monitoring-Fläche)
                    </td>
                  </tr>

                  <tr className="tableHeader3">
                    <td
                      className="column"
                      style={{
                        border: "none",
                        backgroundColor: "white",
                        fontWeight: "normal",
                      }}
                    >
                      Standort (LKR)
                    </td>
                    <td
                      className="column"
                      style={{
                        border: "none",
                        backgroundColor: "white",
                        fontWeight: "normal",
                      }}
                    >
                      Sorte (Auflauftermin)
                    </td>
                    <td
                      className="column"
                      style={{
                        border: "none",
                        backgroundColor: "white",
                        fontWeight: "normal",
                      }}
                    >
                      Befall (unbehandelt)
                    </td>
                    <td
                      className="column"
                      style={{
                        border: "none",
                        backgroundColor: "white",
                        fontWeight: "normal",
                      }}
                    >
                      Anzahl Spritzungen
                    </td>
                    <td
                      className="column"
                      style={{
                        border: "none",
                        backgroundColor: "white",
                        fontWeight: "normal",
                      }}
                    >
                      Phytophthora Befall
                    </td>
                    <td
                      className="column"
                      style={{
                        border: "none",
                        backgroundColor: "white",
                        fontWeight: "normal",
                      }}
                    >
                      Alternaria Befall
                    </td>
                  </tr>

                  {weatherStationData.emailScoutingTables.map((field, idx) => (
                    <tr key={idx}>
                      <td
                        className="data-column"
                        rowSpan={1}
                        style={{
                          border: "2px solid rgb(237 237 237)",
                        }}
                      >
                        {field.location}
                      </td>
                      <td
                        className="data-column"
                        style={{
                          border: "2px solid rgb(237 237 237)",
                        }}
                      >
                        {field.variety}
                      </td>
                      <td
                        className="data-column"
                        style={{
                          border: "2px solid rgb(237 237 237)",
                        }}
                      >
                        {field.infestation}
                      </td>
                      <td
                        className="data-column"
                        style={{
                          border: "2px solid rgb(237 237 237)",
                        }}
                      >
                        {field.numberOfInjection}
                      </td>
                      <td
                        align="center"
                        className="data-column"
                        style={{
                          border: "2px solid rgb(237 237 237)",
                        }}
                      >
                        <img
                          src={
                            infestationColor.find(
                              (inf) => inf.key === field.pytophthoraInfestation,
                            )?.icon
                          }
                          alt={
                            infestationColor.find(
                              (inf) => inf.key === field.pytophthoraInfestation,
                            )?.key
                          }
                        />
                      </td>
                      <td
                        className="data-column"
                        style={{
                          border: "2px solid rgb(237 237 237)",
                        }}
                      >
                        <img
                          src={
                            infestationColor.find(
                              (inf) => inf.key === field.alternariaInfestation,
                            )?.icon
                          }
                          alt={
                            infestationColor.find(
                              (inf) => inf.key === field.alternariaInfestation,
                            )?.key
                          }
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ))}
          </div>
        </span>
        <span style={{ width: "5%", display: "inline-block" }}></span>
      </div>

      <div className="legends-container" style={{ paddingLeft: "0px" }}>
        <span style={{ width: "5%", display: "inline-block" }}></span>
        <span style={{ width: "90%", display: "inline-block" }}>
          <div className="main-legend" style={{ fontWeight: "normal" }}>
            Legende
          </div>

          <div className="legends">
            <div className="legend">
              <div className="legend-title" style={{ fontWeight: "bold" }}>
                Erläuterung Befall Phytophthora
              </div>
              <div className="legend-row flex-legends">
                {explanationPhytophthoraInfestationData.map(
                  (phInfestation, idx) => (
                    <div className="legend-item"
                      key={idx}
                      style={{ whiteSpace: "nowrap" }}>
                      <span
                        className="item-label"
                        style={{ marginLeft: "0px" }}
                      >
                        {phInfestation.key}
                      </span>
                      &nbsp;&nbsp;
                      <img src={phInfestation.icon} alt={phInfestation.key} />
                    </div>
                  ),
                )}
              </div>
            </div>

            <div className="legend">
              <div className="legend-title" style={{ fontWeight: "bold" }}>
                Erläuterung Befall Alternaria
              </div>

              <div className="legend-row flex-legends">
                {explanationAlternariaInfestationData.map(
                  (phInfestation, idx) => (
                    <div className="legend-item" key={idx} style={{ whiteSpace: "nowrap" }}>
                      <span
                        className="item-label"
                        style={{ marginLeft: "0px" }}
                      >
                        {phInfestation.key}
                      </span>
                      &nbsp;&nbsp;
                      <img src={phInfestation.icon} alt={phInfestation.key} />
                    </div>
                  ),
                )}
              </div>
            </div>

            <div className="legend tendency">
              <div className="legend-title" style={{ fontWeight: "bold" }}>
                Tendenz
              </div>

              <div className="legend-row five-legends flex-legends">
                {tendencyData.map((tendency, idx) => (
                  <div className="legend-item" key={idx} style={{ whiteSpace: "nowrap" }}>
                    <span className="item-label" style={{ marginLeft: "0px" }}>
                      {tendency.key}
                    </span>
                    &nbsp;&nbsp;
                    <img src={tendency.icon} alt={tendency.key} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </span>
        <span style={{ width: "5%", display: "inline-block" }}></span>
      </div>
    </div>
  );
};

export default EmailTemplate;
